function setAdvertisers(state, advertisers) {
  state.advertisers = advertisers
}

function setAdvertiserDetails(state, advertiserDetails) {
  if (state.filters.startDate && state.filters.endDate) {
    const startDateFilter = new Date(state.filters.startDate)
    const endDateFilter = new Date(state.filters.endDate)
    const campaignsFilter = advertiserDetails.campaigns.filter((campaign) => {
      const startDate = new Date(+campaign.startDate)
      startDate.setHours(0, 0, 0, 0)
      const endDate = new Date(+campaign.endDate)
      endDate.setHours(0, 0, 0, 0)
      return startDate >= startDateFilter && endDate <= endDateFilter
    })
    state.advertiserDetails = { ...advertiserDetails, campaigns: campaignsFilter }
  } else {
    state.advertiserDetails = advertiserDetails
  }
}

function setSearchTerm(state, value) {
  state.searchTerm = value
}

function setFilters(state, filters) {
  state.filters = filters
}

function setEditableAdvertiserFields(state, advertiserDetails) {
  state.editableAdvertiserFields = {
    id: advertiserDetails.id,
    name: advertiserDetails.name,
  }
}

function createAdvertiserDetails(state) {
  state.advertiserDetails = {
    name: undefined,
  }
  state.editableAdvertiserFields = {
    name: undefined,
  }
}

export default{
  setAdvertisers,
  setAdvertiserDetails,
  setSearchTerm,
  setFilters,
  setEditableAdvertiserFields,
  createAdvertiserDetails,
}



// WEBPACK FOOTER //
// ./src/store/modules/advertiser/advertiser.mutations.js